import breakpoints from "core/breakpoints";

export const placeholderText = ({ browserWidth, searchPlaceholderText }) => {
    let placeholder;

    if (browserWidth > breakpoints.beforeDesktop.px) {
        // desktop hero search placeholder:
        placeholder = searchPlaceholderText.desktop;
    } else if (browserWidth > breakpoints.beforeTablet.px) {
        // tablet hero search placeholder:
        placeholder = searchPlaceholderText.tablet;
    } else {
        // mobile hero search placeholder:
        placeholder = searchPlaceholderText.mobile;
    }

    return placeholder;
};

// this helper generates placeholder input text based on browser width; when we reuse it for other pages we can put it in a global place.
